var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.946.622L4.593 8.683 2.376 6.315c-.408-.385-1.05-.408-1.517-.082-.455.339-.583.934-.303 1.412l2.625 4.27c.257.397.7.642 1.202.642.478 0 .933-.245 1.19-.642.42-.548 8.434-10.103 8.434-10.103C15.058.738 13.787-.207 12.947.61v.012z"
  })));
}
export default SvgFeatureCheckIcon;